import { useQuery } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { ExtractFnReturnType, QueryConfig } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

const url = `${PREFIX_URL}/projects/:projectId/scope`;

export type GetScopeResponse = {
  'transactions-volume': number;
};

export const projectScopeKey = ['project-profile-scope-key'];

export const getScope = ({ projectId }: { projectId: number }): Promise<GetScopeResponse> => {
  const URL = generateRoutePath(url, { projectId });

  return axios.get(URL);
};
type QueryFnType = typeof getScope;

type UseGetScopeOptions = {
  projectId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useGetScope = ({ projectId, config }: UseGetScopeOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: [projectScopeKey, projectId],
    queryFn: () => getScope({ projectId }),
    cacheTime: 0,
    ...config,
  });
};
